// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"685":"7ca60fff","692":"2d8ffd0a","767":"e823892d"}[chunkId] + ".chunk.css";
};